import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "RegionAnalysisVolume"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M11.25 17.2238C8.59744 17.1196 5.99739 16.4523 3.6225 15.2662C4.96949 18.719 8.29384 20.9942 12 21V22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12H21C20.9967 11.5757 20.9634 11.1521 20.9002 10.7325C15.4284 7.42254 8.57164 7.42254 3.09975 10.7325C3.03662 11.1521 3.00329 11.5757 3 12C3.0032 12.4248 3.03654 12.8489 3.09975 13.269C5.5675 14.7581 8.37032 15.6023 11.25 15.7238V17.2238ZM20.3775 8.7345C19.0307 5.28148 15.7063 3.00589 12 3C8.29363 3.00589 4.96923 5.28148 3.62248 8.7345C8.89403 6.08828 15.1059 6.08828 20.3775 8.7345ZM22.5 17.25V15.75H21V14.25H19.5V15.75H17.25V14.25H15.75V15.75H14.25V17.25H15.75V19.5H14.25V21H15.75V22.5H17.25V21H19.5V22.5H21V21H22.5V19.5H21V17.25H22.5ZM17.25 19.5H19.5V17.25H17.25V19.5Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/RegionAnalysisVolume.vue"]]);
